module.exports = __webpack_public_path__ + "img/escalator1.79e4dddb.png";